export const hasNoEmptyStrings = (listToCheck?: string[]) => {
  if (listToCheck) {
    return listToCheck.some(item => item !== '');
  } else {
    return false;
  }
};
